import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export const ProviderQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  },
});

const QueryProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <QueryClientProvider client={ProviderQueryClient}>
      {children}
    </QueryClientProvider>
  );
};

export default QueryProvider;
